import React from 'react';
import { Star, Quote } from 'lucide-react';
export const Testimonials: React.FC = () => {
  const testimonials = [{
    name: 'Martina L.',
    role: 'Estudiante de Instrumentación, UBA',
    text: 'Me salvó en mis primeras prácticas. Estaba aterrorizada de equivocarme con las pinzas de hemostasia y la forma en que lo explica visualmente hizo que me acordara de todo al instante.'
  }, {
    name: 'Sofía R.',
    role: 'Instrumentadora, Córdoba',
    text: 'Ojalá hubiera tenido esto en primer año. Los libros tradicionales son puro texto aburrido. Este atlas va directo al grano, te muestra lo que necesitás saber para no pasar vergüenza en quirófano.'
  }, {
    name: 'Julieta M.',
    role: 'Estudiante de Medicina, UNLP',
    text: 'Compré el atlas porque en la rotación de cirugía me sentía perdidísima. La sección de armado de mesa por tipo de cirugía es ORO PURO. Ya no me quedo paralizada cuando piden material.'
  }, {
    name: 'Camila G.',
    role: 'Instrumentadora Recibida, Rosario',
    text: 'Incluso ya recibida lo uso para repasar antes de cirugías complejas que no hago seguido. Los bonos de vocabulario y referencia rápida los tengo en el celular siempre.'
  }, {
    name: 'Valentina C.',
    role: 'Estudiante de Instrumentación, Mendoza',
    text: 'El precio es un chiste para todo el valor que tiene. Solo el capítulo de cómo manejar el estrés y la presión de los cirujanos vale la pena. Me dio muchísima seguridad.'
  }];
  return <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-210">
          Lo que dicen las futuras y actuales{' '}
          <span className="text-cyan-700" data-id="element-211">colegas</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {testimonials.map((t, index) => <div key={index} className={`relative bg-slate-50 p-6 rounded-2xl border border-slate-200 shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-213">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-cyan-100" data-id="element-214" />
              <div className="flex items-center gap-1 mb-4" data-id="element-215">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-216" />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-217">
                "{t.text}"
              </p>
              <div className="border-t border-slate-200 pt-4" data-id="element-218">
                <h4 className="font-bold text-slate-900 text-sm" data-id="element-219">{t.name}</h4>
                <p className="text-xs text-slate-500" data-id="element-220">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};